"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCurrencyToSign = transformCurrencyToSign;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformCurrencyToSign(currency) {
    if (currency === legacy_enums_1.Currency.Euro) {
        return "€";
    }
    if (currency === legacy_enums_1.Currency.Dollar ||
        currency === legacy_enums_1.Currency.AustralianDollar ||
        currency === legacy_enums_1.Currency.CanadianDollar ||
        currency === legacy_enums_1.Currency.NewZealandDollar) {
        return "$";
    }
    if (currency === legacy_enums_1.Currency.BritishPound) {
        return "£";
    }
    if (currency === legacy_enums_1.Currency.CzechKoruna) {
        return "Kč";
    }
    return "";
}
//# sourceMappingURL=transformCurrencyToSign.js.map